{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izaberite stavku",
  "tableResizer": "Promena veličine"
}
